import PropTypes from 'prop-types';

function FieldTypeInput(props) {
  const { handleFieldTypeInput } = props;

  return (
    <div className="form-group">
      <label className="control-label">Field type</label>
      <select id="#fieldType" className="form-control" onChange={handleFieldTypeInput}>
        <option value="string">Single Line Field</option>
        <option value="text">Descriptive Field</option>
        <option value="checkbox">Checkbox Field</option>
        <option value="date">Date Field</option>
        <option value="dropdown">Dropdown Field</option>
      </select>
      <hr />
    </div>
  );
}

FieldTypeInput.propTypes = {
  handleFieldTypeInput: PropTypes.func,
};

export default FieldTypeInput;
